import { useConfigLoader } from '@scts/utilities';
import { CaseDocument } from '@scts/models';
import {
  constructDocumentApiUrl,
  standardDateFormatter,
} from '@scts/utilities';
import { Table } from 'react-bootstrap';
import { DownloadLink } from '../download/download-link';
import './document-component.scss';

export interface DocumentProps {
  documents: CaseDocument[];
  caseRefDashes: string;
}

const DocumentComponent = (documentProps: DocumentProps) => {
  const { data } = useConfigLoader();
  return (
    <div className="table-documents">
      <Table striped hover responsive>
        <thead>
          <tr>
            <th>File Name</th>
            <th>Created</th>
            <th className="text-center">Download</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            documentProps.documents.map((doc, index) => (
              <tr key={index} className="document-item">
                <td className="align-middle">{doc.filename}</td>
                <td className="align-middle">
                  {standardDateFormatter(new Date(doc.createdOn))}
                </td>
                <td className="align-middle table-download text-center">
                  <>
                    <span className="visually-hidden">
                      download case file {doc.filename}
                    </span>

                    <DownloadLink
                      apiUrl={constructDocumentApiUrl(
                        data.apiUrl,
                        documentProps.caseRefDashes,
                        doc.publicDocumentId
                      )}
                      fileName={doc.filename}
                    />
                  </>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DocumentComponent;
